import React from 'react';
import styled, { css } from 'styled-components';
import { Text } from '../..';
export var BadgeColorPalette;
(function (BadgeColorPalette) {
    BadgeColorPalette["New"] = "NEW";
    BadgeColorPalette["Promotion"] = "PROMOTION";
    BadgeColorPalette["Featured"] = "FEATURED";
    BadgeColorPalette["Default"] = "DEFAULT";
    BadgeColorPalette["FreeShipping"] = "FREE_SHIPPING";
})(BadgeColorPalette || (BadgeColorPalette = {}));
const newStyle = css `
  background-color: ${({ theme }) => theme.colors.alert};
  color: ${({ theme }) => theme.colors.brown};
`;
const featuredStyle = css `
  background-color: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.white};
`;
const promotionStyle = css `
  background-color: ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.white};
`;
const freeShippingStyle = css `
  background-color: ${({ theme }) => theme.colors.success};
  color: ${({ theme }) => theme.colors.white};
`;
const defaultStyle = css `
  background-color: ${({ theme }) => theme.colors.gray100};
  color: ${({ theme }) => theme.colors.gray700};
`;
const Component = styled(Text) `
  border-radius: ${({ theme }) => theme.space.x4};
  padding: ${({ theme }) => theme.space.x4};
  white-space: nowrap;

  ${({ colorPalette }) => {
    if (colorPalette === BadgeColorPalette.New) {
        return newStyle;
    }
    if (colorPalette === BadgeColorPalette.Promotion) {
        return promotionStyle;
    }
    if (colorPalette === BadgeColorPalette.FreeShipping) {
        return freeShippingStyle;
    }
    if (colorPalette === BadgeColorPalette.Featured) {
        return featuredStyle;
    }
    return defaultStyle;
}}
`;
export const Badge = ({ colorPalette, text }) => {
    return (React.createElement(Component, { textTransform: "uppercase", textSize: "x0", colorPalette: colorPalette, isBold: true }, text));
};
Badge.defaultProps = {
    colorPalette: BadgeColorPalette.Default,
};
//# sourceMappingURL=index.js.map